import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import { getVisibleSensorAnimation } from "../assets/js/utils";
import useWindowSize from "./hooks/useWindowSize";

function TitleParagraphs({ items }) {
  const windowWidth = useWindowSize();
  return (
    <>
      {items.map((item, index) => (
        <div key={index} className="title-paragraphs__block">
          <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
              <h5
                className="title-paragraphs__heading"
                style={getVisibleSensorAnimation(
                  isVisible,
                  "fadeInReverse 1s backwards"
                )}
              >
                {item.heading}
              </h5>
            )}
          </VisibilitySensor>
          {item.paragraphs.map((paragraph, index) => (
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <p
                  className="title-paragraphs_text"
                  key={index}
                  style={getVisibleSensorAnimation(
                    isVisible,
                    `fadeIn 1s ${
                      windowWidth > 767 ? index * 0.2 : 0
                    }s backwards`
                  )}
                >
                  {paragraph}
                </p>
              )}
            </VisibilitySensor>
          ))}
        </div>
      ))}
    </>
  );
}

export default TitleParagraphs;
